import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SpecPackListClasses = 'container';

const specPackListStyles = makeStyles<ISpcTheme, SpecPackListClasses>(
  () => ({
    container: {},
  }),
  { name: 'GqlCustomise_SpecPackList' },
);

export default specPackListStyles;
